enum OtpType {
    Unset = -1,
    Email,
    Sms,
}

function strToEnum(value: string) {
    const strEnum = value as unknown as OtpType;
    return OtpType[strEnum];
}

function otpTypeEnumToString(otpType: OtpType | string) {
    switch (otpType) {
        case OtpType.Email:
            return "Email";
        case OtpType.Sms:
            return "Sms";
        default:
            return "Unset";
    }
}

export { OtpType, strToEnum, otpTypeEnumToString };
